var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"modalName":"watermetersRegisterModal","title":"REJESTR WODOMIERZY","buttons":[],"register":_vm.register}},[_c('WatermetersTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b931c69","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/watermeters/modals/WatermetersRegister.vue
// module id = 1742
// module chunks = 0